/*!
 * Limmo Quick Variant (LQV)
 * Ürün kartlarında modern hızlı varyant seçimi – masaüstü panel + mobil bottom sheet.
 * Tema'nın (nuranium.js) varyant & sepete ekle mantığını kullanır; sadece deneyimi iyileştirir.
 */
(function ($) {
  'use strict';
  if (!$ || window.__lqvReady) return;
  window.__lqvReady = true;

  var SHEET_MQ = window.matchMedia('(hover: none), (max-width: 767px)');
  var $doc = $(document);
  var $html = $('html');
  var state = { card: null, host: null, backdrop: null, placeholder: null, panel: null, trigger: null };
  var lastAddBtn = null;
  var activeCta = null;

  function isSheetMode() { return SHEET_MQ.matches; }

  /* ---------------------------------------------------------------
   * Kampanya etiketleri: bitiş tarihi geçmişse gizle
   * (Sayfa önbellekte kalsa bile süresi dolan kampanya görünmez)
   * ------------------------------------------------------------- */
  function hideExpiredBadges() {
    var now = Math.floor(Date.now() / 1000);
    $('[data-lqv-end]').each(function () {
      var end = parseInt(this.getAttribute('data-lqv-end'), 10);
      if (end && now > end) {
        var $wrap = $(this).closest('.lqv-badges');
        $(this).remove();
        if ($wrap.length && !$wrap.children().length) $wrap.remove();
      }
    });
  }
  $(hideExpiredBadges);
  $doc.ajaxComplete(function () { setTimeout(hideExpiredBadges, 50); });

  /* ---------------------------------------------------------------
   * Masaüstü: çok seçenekli panel kartdan daha geniş açılır.
   * Slider (overflow:hidden) sınırları içinde kalacak şekilde
   * yatay ve dikey konumu hesaplanır.
   * ------------------------------------------------------------- */
  var PANEL_MIN_WIDTH = 340;
  function placePanel(card) {
    if (isSheetMode() || !card.classList.contains('lqv-multi')) return;
    var inner = card.querySelector('.inner-top');
    var panel = card.querySelector('[data-lqv-panel]');
    if (!inner || !panel) return;
    var cr = inner.getBoundingClientRect();
    var clip = card.closest('.slick-list');
    var vw = document.documentElement.clientWidth;
    var kr;
    if (clip) {
      kr = clip.getBoundingClientRect();
    } else {
      var box = card.closest('.container') || card.closest('.row');
      var br = box ? box.getBoundingClientRect() : { left: 0, right: vw };
      kr = { left: Math.max(0, br.left), right: Math.min(vw, br.right), top: -1e6, bottom: 1e6 };
    }
    var gap = 4;
    var avail = Math.max(0, kr.right - kr.left - gap * 2);
    var w = Math.min(Math.max(cr.width + 12, PANEL_MIN_WIDTH), avail || cr.width + 12);
    var left = (cr.width - w) / 2;
    if (cr.left + left < kr.left + gap) left = kr.left + gap - cr.left;
    if (cr.left + left + w > kr.right - gap) left = kr.right - gap - w - cr.left;
    card.style.setProperty('--lqv-pw', Math.round(w) + 'px');
    card.style.setProperty('--lqv-pl', Math.round(left) + 'px');

    // dikey: slider'ın altından taşarsa yukarı kaydır
    var top = -6;
    var h = panel.offsetHeight;
    if (clip && cr.top + top + h > kr.bottom - gap) {
      top = Math.max(kr.top + gap - cr.top, kr.bottom - gap - h - cr.top);
    }
    card.style.setProperty('--lqv-pt', Math.round(top) + 'px');
  }
  $doc.on('mouseenter focusin', '.lqv-card', function () { placePanel(this); });

  /* ---------------------------------------------------------------
   * Adet seçici
   * ------------------------------------------------------------- */
  function syncQtyButtons($wrap) {
    var v = parseInt($wrap.find('.lqv-qty-input').val(), 10) || 1;
    $wrap.find('[data-lqv-step="-1"]').prop('disabled', v <= 1);
  }

  $doc.on('click', '[data-lqv-step]', function (e) {
    e.preventDefault();
    var $wrap = $(this).closest('[data-lqv-qty]');
    var $input = $wrap.find('.lqv-qty-input');
    var v = (parseInt($input.val(), 10) || 1) + parseInt($(this).attr('data-lqv-step'), 10);
    $input.val(Math.max(1, Math.min(999, v))).trigger('change');
    syncQtyButtons($wrap);
  });

  $doc.on('change blur', '.lqv-qty-input', function () {
    var v = parseInt(this.value, 10);
    this.value = isNaN(v) || v < 1 ? 1 : Math.min(999, v);
    syncQtyButtons($(this).closest('[data-lqv-qty]'));
  });

  $(function () { $('[data-lqv-qty]').each(function () { syncQtyButtons($(this)); }); });

  /* ---------------------------------------------------------------
   * Varyant değişince görseli güncelle (varyant görseli varsa)
   * ------------------------------------------------------------- */
  function getVariants($scope) {
    var data = $scope.data('json-product');
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (err) { data = null; } }
    return data && data.variants ? data.variants : [];
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // Etikete tıklanınca daima kendi panelindeki radyoyu seç
  // (aynı ürün sayfada birden fazla kez listelenirse id çakışmasını önler)
  $doc.on('click', '.lqv-panel .swatch-element > label', function (e) {
    var $input = $(this).siblings('input.single-option-selector').first();
    if (!$input.length) return;
    e.preventDefault();
    if ($input.prop('disabled') || $input.prop('checked')) return;
    $input.prop('checked', true).trigger('change');
  });

  $doc.on('change', '.lqv-panel .single-option-selector', function () {
    var $panel = $(this).closest('.lqv-panel');
    // Tema JS'i varyant id'sini güncelledikten sonra çalış
    setTimeout(function () {
      var $scope = $panel.closest('.item-product');
      var id = parseInt($panel.find('.current_variant_id').val(), 10);
      var variant = getVariants($scope).filter(function (v) { return v.id === id; })[0];
      var $card = state.panel && state.panel.is($panel) ? state.card : $scope;

      // renk etiketi
      $panel.find('.lqv-group--color').each(function () {
        $(this).find('.lqv-label-value').text($(this).find('input:checked').val() || '');
      });

      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      var src = variant.featured_image.src;
      if ($card && $card.length) {
        $card.find('.thumbnail-container .product__thumbnail').attr({
          src: imgUrl(src, 800),
          srcset: imgUrl(src, 400) + ' 400w, ' + imgUrl(src, 800) + ' 800w, ' + imgUrl(src, 1200) + ' 1200w'
        });
      }
      $panel.find('.lqv-sheet-img').attr({ src: imgUrl(src, 240), srcset: imgUrl(src, 120) + ' 120w, ' + imgUrl(src, 240) + ' 240w' });
    }, 0);
  });

  /* ---------------------------------------------------------------
   * Mobil bottom sheet
   * ------------------------------------------------------------- */
  function openSheet($card, $trigger) {
    if (state.host) closeSheet(true);
    var $panel = $card.find('[data-lqv-panel]').first();
    if (!$panel.length) return;

    var placeholder = document.createComment('lqv-panel');
    $panel[0].parentNode.insertBefore(placeholder, $panel[0]);

    var $backdrop = $('<div class="lqv-backdrop" aria-hidden="true"></div>');
    var $host = $('<div class="item-product lqv-sheet-host" role="dialog" aria-modal="true"></div>')
      .attr('data-json-product', $card.attr('data-json-product'))
      .attr('data-product-id', $card.attr('data-product-id'))
      .attr('aria-label', $.trim($card.find('.product__title').first().text()));

    $host.append($panel);
    $('body').append($backdrop, $host);

    state = { card: $card, host: $host, backdrop: $backdrop, placeholder: placeholder, panel: $panel, trigger: $trigger };
    $html.addClass('lqv-lock');

    // reflow → animasyon
    void $host[0].offsetHeight;
    $backdrop.addClass('is-open');
    $host.addClass('is-open');

    setTimeout(function () {
      var $focus = $panel.find('input.single-option-selector:checked').first();
      ($focus.length ? $focus : $panel.find('.lqv-close')).trigger('focus');
    }, 380);
  }

  function syncCardPrice() {
    if (!state.card || !state.panel) return;
    var $p = state.panel.find('.lqv-sheet-price [data-price-grid]');
    var $c = state.panel.find('.lqv-sheet-price [data-compare-price-grid]');
    state.card.find('.product__info [data-price-grid]').html($p.html());
    state.card.find('.product__info [data-compare-price-grid]').html($c.html());
  }

  function closeSheet(immediate) {
    if (!state.host) return;
    var s = state;
    state = { card: null, host: null, backdrop: null, placeholder: null, panel: null, trigger: null };

    s.host.removeClass('is-open is-dragging');
    s.host[0].style.removeProperty('--lqv-drag');
    s.backdrop.removeClass('is-open');
    $html.removeClass('lqv-lock');

    var finish = function () {
      // fiyatı karta yansıt, paneli yerine geri koy
      var tmp = state; state = s; syncCardPrice(); state = tmp;
      if (s.placeholder.parentNode) {
        s.placeholder.parentNode.insertBefore(s.panel[0], s.placeholder);
        s.placeholder.parentNode.removeChild(s.placeholder);
      }
      s.host.remove();
      s.backdrop.remove();
      if (s.trigger && s.trigger.length && !immediate) s.trigger.trigger('focus');
    };
    if (immediate) finish(); else setTimeout(finish, 400);
  }

  $doc.on('click', '[data-lqv-open]', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $card = $btn.closest('.lqv-card');
    if ($btn.prop('disabled')) return;

    // Tek varyantlı ürün → doğrudan sepete ekle
    if ($card.hasClass('lqv-single')) {
      var $add = $card.find('[data-lqv-panel] .lqv-add').first();
      if (!$add.length) return;
      if ($add.hasClass('product-form__cart-submit')) {
        activeCta = $btn.addClass('is-loading');
        lastAddBtn = $add;
        $add.trigger('click');
      } else {
        $add.closest('form').trigger('submit');
      }
      return;
    }
    openSheet($card, $btn);
  });

  $doc.on('click', '.lqv-backdrop, .lqv-sheet-host .lqv-close', function (e) {
    e.preventDefault();
    closeSheet();
  });

  $doc.on('keydown', function (e) {
    if (e.key === 'Escape' && state.host) closeSheet();
  });

  // Ekran masaüstüne geçerse sheet'i kapat
  var onMQ = function () { if (!isSheetMode() && state.host) closeSheet(true); };
  if (SHEET_MQ.addEventListener) SHEET_MQ.addEventListener('change', onMQ); else if (SHEET_MQ.addListener) SHEET_MQ.addListener(onMQ);

  // Aşağı sürükleyerek kapatma
  (function () {
    var startY = null, dy = 0;
    $doc.on('touchstart', '.lqv-sheet-host .lqv-sheet-head', function (e) {
      if (!e.originalEvent.touches) return;
      startY = e.originalEvent.touches[0].clientY; dy = 0;
      state.host && state.host.addClass('is-dragging');
    });
    $doc.on('touchmove', '.lqv-sheet-host .lqv-sheet-head', function (e) {
      if (startY === null || !state.host) return;
      dy = Math.max(0, e.originalEvent.touches[0].clientY - startY);
      state.host[0].style.setProperty('--lqv-drag', dy + 'px');
    });
    $doc.on('touchend touchcancel', '.lqv-sheet-host .lqv-sheet-head', function () {
      if (startY === null || !state.host) return;
      startY = null;
      state.host.removeClass('is-dragging');
      if (dy > 90) closeSheet();
      else state.host[0].style.removeProperty('--lqv-drag');
    });
  })();

  /* ---------------------------------------------------------------
   * Sepete ekleme geri bildirimi
   * ------------------------------------------------------------- */
  $doc.on('click', '.lqv-panel .lqv-add', function () { lastAddBtn = $(this); });

  function flashAdded($btn, text) {
    if (!$btn || !$btn.length) return;
    var $txt = $btn.find('.add-to-cart-text, .lqv-cta-text').first();
    var original = $btn.data('lqv-text') || $txt.text();
    $btn.data('lqv-text', original);
    $txt.text(text);
    $btn.addClass('lqv-added');
    clearTimeout($btn.data('lqv-timer'));
    $btn.data('lqv-timer', setTimeout(function () {
      $btn.removeClass('lqv-added');
      $txt.text(original);
    }, 1800));
  }

  $doc.ajaxSuccess(function (evt, xhr, settings) {
    if (!settings || !settings.url || settings.url.indexOf('/cart/add') === -1) return;
    var $btn = lastAddBtn; lastAddBtn = null;

    if (activeCta) {
      activeCta.removeClass('is-loading');
      flashAdded(activeCta, 'Eklendi ✓');
      activeCta = null;
    } else if ($btn) {
      flashAdded($btn, 'Eklendi ✓');
    }

    if ($btn) {
      var $q = $btn.closest('form').find('.lqv-qty-input');
      $q.val(1); syncQtyButtons($q.closest('[data-lqv-qty]'));
    }
    if (state.host) setTimeout(function () { closeSheet(); }, 450);
  });

  $doc.ajaxError(function (evt, xhr, settings) {
    if (!settings || !settings.url || settings.url.indexOf('/cart/add') === -1) return;
    if (activeCta) { activeCta.removeClass('is-loading'); activeCta = null; }
    lastAddBtn = null;
  });
})(window.jQuery);
